import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

const mlAxios = axios.create();
mlAxios.interceptors.request.use((config) => {
    const token = localStorage.getItem('token') || localStorage.getItem('emis_auth_token');
    if (token) {
        config.headers.Authorization = `Token ${token}`;
    }
    return config;
});

export interface StudentData {
    student_id: string;
    student_name: string;
    school_id: string;
    school_name: string;
    attendance_last_30_days?: number;
    attendance_last_60_days?: number;
    attendance_last_90_days?: number;
    failed_subjects_count?: number;
    max_consecutive_absences?: number;
    current_gpa?: number;
    [key: string]: any;
}

export interface DropoutRiskPrediction {
    id: number;
    student_id: string;
    student_name: string;
    school_id: string;
    school_name: string;
    risk_score: number;
    risk_level: 'low' | 'medium' | 'high' | 'critical';
    contributing_factors: string[];
    confidence_score: number;
    prediction_date: string;
}

export interface InterventionRecommendation {
    id: number;
    intervention_type: string;
    intervention_type_display: string;
    priority: string;
    priority_display: string;
    description: string;
    rationale: string;
    status: string;
    status_display: string;
    outcome: string;
    estimated_timeline: string;
    recommended_date: string;
}

export const mlAnalyticsAPI = {
    // Dashboard
    getDashboard: () => {
        return mlAxios.get(`${API_URL}/ml-analytics/dropout-risk/dashboard/`);
    },

    // Predictions
    predictDropoutRisk: (studentData: StudentData | StudentData[]) => {
        return mlAxios.post(`${API_URL}/ml-analytics/dropout-risk/predict/`, {
            student_data: studentData
        });
    },

    getAtRiskStudents: (params?: { risk_level?: string; school_id?: string }) => {
        return mlAxios.get(`${API_URL}/ml-analytics/dropout-risk/at-risk/`, { params });
    },

    getStudentRisk: (studentId: string) => {
        return mlAxios.get(`${API_URL}/ml-analytics/dropout-risk/student/${studentId}/`);
    },

    // Interventions
    trackInterventionOutcome: (data: {
        intervention_id: number;
        outcome: string;
        notes?: string;
        attendance_after?: number;
    }) => {
        return mlAxios.post(`${API_URL}/ml-analytics/interventions/track-outcome/`, data);
    },

    getInterventionEffectiveness: () => {
        return mlAxios.get(`${API_URL}/ml-analytics/interventions/effectiveness/`);
    },
};
